import {LayoutType} from "./constants";
import {UseFullSizeImages} from "../../../config";
import {getCurrentLayout} from "../../appLayout";

let layouts = {};
Object.keys(LayoutType).forEach(layoutName => {
  layouts[layoutName] = {
    center_island_sink: 3100,
    background_bg: 70000,
  };
});

const getLayerDimensions = (layer, currentLayout, canvasDimensions) => {
  const fullImagesFactor = UseFullSizeImages ? 177.77 : 100;
  const sizeFactor = fullImagesFactor / 100;
  const {coords} = layer;

  if (!coords) {
    return null
  }

  const COORDS_MAX = 1;

  const x1Percentage = (coords.min_x * 100) / COORDS_MAX;
  const x2Percentage = (coords.max_x * 100) / COORDS_MAX;
  const y1Percentage = (coords.min_y * 100) / COORDS_MAX;
  const y2Percentage = (coords.max_y * 100) / COORDS_MAX;
  let x1 = sizeFactor*((canvasDimensions.width * x1Percentage) / 100);
  let x2 = sizeFactor*((canvasDimensions.width * x2Percentage) / 100);
  let y1 = sizeFactor*((canvasDimensions.height * y1Percentage) / 100);
  let y2 = sizeFactor*((canvasDimensions.height * y2Percentage) / 100);
  return {
    polygonArray: [[x1, y1], [x2, y1], [x2, y2], [x1, y2]],
    width: (x2 - x1),
    height:(y2 - y1)
  };
};

const getMenuByHoveredLayer = (layer) => {
  const layout = getCurrentLayout();
  const featureGroup = layout.getFeatureGroupByPartId(layer.partId);
  if (featureGroup) {
    return {
      parent: featureGroup.getParent().partName,
      child: featureGroup.partName
    }
  }
  return ""
};

export default {
  layouts,
  getMenuByHoveredLayer,
  getLayerDimensions
}


